const COLORS = {
  primaryBlue: "#0A1F8F",
  darkBlue: "#00085B",
  yellow: "#D14836",
  yellowHover: "#FFD700", 
  white: "#FFFFFF",
  gray: "#757575",
  lightGray: "#E7E9F4",
  buttonColor: '#A62639',
  whiteColor:'#FFFFFF',
  secondaryBlue:'#173248',
  // Colors used in Paraquat components
  darkBlueAlt: "#000000",
  yellowAlt: "#FF0000",
  creamLight: "#FDF9ED",
  lightBlue: "#F6F7FD",
  lightBlueAlt: "#F4F6FC",
  // Add more as needed
};

export default COLORS; 